export const PHONE_PATTERN = /^03[0-9]{9}$/;
export const PHONE_MESSAGE = "Enter a valid mobile number (03XXXXXXXXX)";
export const PICKUP_SLOTS = [20, 25, 30, 35, 40] as const;
export const ORDER_TYPES = ["delivery", "pickup"] as const;
export const PAYMENT_METHODS = ["cod"] as const;

export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const COD_PAYMENT = {
  method: "cod" as const,
  enabled: true,
  displayName: "Cash on Delivery",
};
